module.exports = __webpack_public_path__ + "assets/ziyuan_18.4a35a504.svg";